module.exports = __webpack_public_path__ + "static/media/banner-sample-03.5dedf704.jpg";